export const colors = {
  navy: '#0f2947',
  navyLight: '#1e3a5f',
  navyMid: '#334e68',
  inkSecondary: '#505f7c',
  ink: '#122345',
  inkMuted: '#667799',
  surface: '#f6f7f9',
  surfaceAlt: '#fcfcfd',
  edge: '#d8dde9',
  edgeLight: '#e5e7eb',
  accent: '#3b82f6',
  positive: '#059669',
  negative: '#dc2626',
  highlightActive: '#3b82f6',
};
